export function getMousePosition(
  event: React.MouseEvent<HTMLCanvasElement, MouseEvent>,
  offsets?: [number, number]
) {
  const currentOffsets = offsets ?? [0, 0]
  const [offsetX, offsetY] = currentOffsets

  const x = event.clientX - offsetX
  const y = event.clientY - offsetY
  return [x, y]
}
